import axios from 'axios'

export function getActivityLogsFilters() {
  return axios.get('activity-log/filters')
}

export function findActivityLogs(filterObj) {
  return axios.post('activity-log', filterObj)
}
